import { cn } from '@/lib/utils';

import { XStack, YStack, type StackProps } from '../layout';
import { type TextProps, Text } from '../typography';

export const BannerRoot = ({ className, children, ...props }: StackProps) => {
  return (
    <XStack
      className={cn(
        'gap-4 px-6 py-5 border border-border rounded-lg bg-surface justify-between items-center',
        className
      )}
      {...props}
    >
      {children}
    </XStack>
  );
};

export const BannerContent = ({
  className,
  children,
  ...props
}: StackProps) => {
  return (
    <YStack className={cn('gap-1', className)} {...props}>
      {children}
    </YStack>
  );
};

export const BannerTitle = ({ className, children, ...props }: TextProps) => {
  return (
    <Text className={cn('text-foreground', className)} {...props}>
      {children}
    </Text>
  );
};

export const BannerDescription = ({
  className,
  children,
  ...props
}: TextProps) => {
  return (
    <Text
      size="sm"
      className={cn('text-foreground-muted', className)}
      {...props}
    >
      {children}
    </Text>
  );
};

export const BannerActions = ({
  className,
  children,
  ...props
}: StackProps) => {
  return (
    <XStack className={cn('flex gap-2', className)} {...props}>
      {children}
    </XStack>
  );
};
